


















import Vue from 'vue';
import { CustomField } from '@/types';

export default Vue.extend({
  props: {
    customFields: {
      type: Array as () => CustomField[],
      default() {
        return [];
      },
    },
    enabledCustomFields: {
      type: Array as () => string[],
      default() {
        return [];
      },
    },
  },
  computed: {
    isEmpty(): boolean {
      return (this.customFields.length === 0);
    },
  },
  methods: {
    input(customFieldId: string, value: boolean) {
      if (value) {
        this.$emit('enabled', customFieldId);
      } else {
        this.$emit('disabled', customFieldId);
      }
    },
    isEnabled(customFieldId: string): boolean {
      return this.enabledCustomFields.includes(customFieldId);
    },
  },
});
